module.exports = __webpack_public_path__ + "media/images/kitchen_icon@3x-6be51028.png";